import type { ColProps, RowProps } from '@sravni/react-design-system/lib/Grid';

export const SCREENS = {
  INITIAL: 'initial',
  OTP: 'otp',
  CONSENTS: 'consents',
} as const;

export const FIELD_NAME = {
  PHONE: 'phone',
  NAME: 'name',
  OTP: 'code',
  EMAIL: 'email',
  AGREEMENT_PERSONAL_DATA: 'agreementPersonalData',
  AGREEMENT_ADVERTISING: 'agreementAdvertising',
  REFERENCE_TOKEN: 'referenceToken',
  SERVER: 'root.server',
} as const;

export const FORM_ID = 'sravniAuthInlineForm';
export const UNAUTHORIZED_ERROR_TYPE = 'unauthorized';

export const DEFAULT_SPAN: ColProps['span'] = { mobile: 12, tablet: 4, desktop: 4 };

export const DEFAULT_OFFSET: ColProps['offset'] = { mobile: 0, tablet: 8, desktop: 8 };

export const DEFAULT_GUTTER: RowProps['gutter'] = [16, 16];
